import { Phone } from "lucide-react";
import { Reveal, RevealLine } from "./Reveal";
import { scrollToTarget } from "../lib/smooth";

export const SectionHead = ({ eyebrow, title, intro, align = "left" }) => (
  <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-2xl`}>
    {eyebrow && (
      <Reveal>
        <p className="eyebrow">{eyebrow}</p>
      </Reveal>
    )}
    <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05] mt-4">
      {typeof title === "string" ? <RevealLine>{title}</RevealLine> : title}
    </h2>
    {intro && (
      <Reveal delay={0.12}>
        <p className="mt-5 text-soot leading-relaxed text-base md:text-lg">{intro}</p>
      </Reveal>
    )}
  </div>
);
